import React, {
	createContext,
	useContext,
	useState,
	useEffect,
} from "react";

const ThemeContext = createContext(null);

export function ThemeProvider({ children }) {
	const [dark, setDark] = useState(() => {
		// Persist preference across sessions
		const saved = localStorage.getItem("cff_theme");
		if (saved) return saved === "dark";
		// Respect OS preference if no saved choice
		return window.matchMedia("(prefers-color-scheme: dark)").matches;
	});
	
	useEffect(() => {
		const root = document.documentElement;
		if (dark) {
			root.classList.add("dark");
		} else {
			root.classList.remove("dark");
		}
		localStorage.setItem("cff_theme", dark ? "dark" : "light");
	}, [dark]);
	
	const toggle = () => setDark((prev) => !prev);
	
	return (
		<ThemeContext.Provider value={{ dark, toggle }}>
		{children}
		</ThemeContext.Provider>
	);
}

export const useTheme = () => useContext(ThemeContext);
